import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import GBILogo from '../../../img/logo/good-beef-index.svg';
import PropTypes from 'prop-types';
import './header.scss';
import { logout } from '../../user/actions';
import { isAuthenticated } from '../../util/jwt';
import GBIHeaderBurger from '../../util/buttons/components/GBIHeaderBurger';
import SigninIcon from '../../util/icons/components/SignInIcon';
import { setMobileMenuOpen } from '../actions';
import { menuIsOpen } from '../reducer';
import Signup from '../../user/signup/components/Signup';
// import Account from './Account';
import { getBeefBookDomain, getDashboardDomain } from '../../util/site';

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  setMobileMenuOpen: open => dispatch(setMobileMenuOpen(open))
});

const mapStateToProps = state => ({
  menuOpen: menuIsOpen(state)
});

class Header extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showShadow: false
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  handleScroll () {
    if (this.hideShadowTimeout) {
      clearTimeout(this.hideShadowTimeout);
    }
    this.setState({ showShadow: true });
    this.hideShadowTimeout = setTimeout(() => {
      this.setState({ showShadow: false });
    }, 200);
  }
  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount () {
    if (this.hideShadowTimeout) {
      clearTimeout(this.hideShadowTimeout);
    }
    window.removeEventListener('scroll', this.handleScroll);
  }
  toggleMobileMenu () {
    this.props.setMobileMenuOpen(!this.props.menuOpen);
  }
  render () {
    let className = 'gbi-header';
    if (window.location.pathname === '/animal-spec' &&
      window.pageYOffset === 0) {
      className += ' clear';
    } else if (this.state.showShadow) {
      className += ' shadow';
    } else if (window.pageYOffset !== 0) {
      className += ' light-shadow';
    }
    const signupLabel = isAuthenticated() ? 'contact' : (
      <Fragment>
        <span className="redundant">join/</span>contact
      </Fragment>
    );
    // const contactSignupModal = isAuthenticated() ? (
    //   <Signup buttonLabel="contact" />
    // ) : (
    //   <Signup buttonLabel="join/contact" />
    // );
    const burgerCls = this.props.menuOpen ?
      'gbi-header-burger hidden' : 'gbi-header-burger';
    const navClass = this.props.menuOpen ?
      'main-nav visible' : 'main-nav hidden';
    return (
      <div id='gbi-header' className={ className }>
        <NavLink to='/'>
          <img className='logo'
            src={ GBILogo }
            onClick={ () => this.props.setMobileMenuOpen(false) } />
        </NavLink>
        <GBIHeaderBurger
          onClick={ this.toggleMobileMenu.bind(this) }
          className={ burgerCls } />
        <nav
          className={ navClass }
          onClick={ this.toggleMobileMenu.bind(this) }>
          <NavLink activeClassName="active"
            className="nav-link"
            to='/about'>
            <div data-cy="main-nav-link-text-about"
              className='main-nav-link-text'>
              About
              <div className="line"></div>
            </div></NavLink>
          <NavLink activeClassName="active"
            className="nav-link"
            to='/good-beef'>
            <div data-cy="main-nav-link-text-Good Beef"
              className='main-nav-link-text'>
              Good Beef
              <div className="line"></div>
            </div></NavLink>
          <a href={ getBeefBookDomain() }
            target="_blank"
            className="nav-link"
            rel="noopener noreferrer">
            <div data-cy="main-nav-link-text-listings"
              className='main-nav-link-text'>
              BeefBook <span className="redundant">Listings</span>
              <div className="line"></div>
            </div>
          </a>
          <NavLink activeClassName="active"
            className="nav-link"
            to='/rate-my-animal'>
            <div data-cy="main-nav-link-text-try-it-out"
              className='main-nav-link-text'>
              Try it <span className="redundant">out</span>
              <div className="line"></div>
            </div>
          </NavLink>
          <NavLink activeClassName="active"
            className="nav-link"
            to='/for-farmers'>
            <div data-cy="main-nav-link-text-farmers"
              className='main-nav-link-text'>
              <span className="redundant">for</span> Farmers
              <div className="line"></div>
            </div>
          </NavLink>
          <NavLink activeClassName="active"
            className="nav-link"
            to='/for-consumers'>
            <div data-cy="main-nav-link-text-consumers"
              className='main-nav-link-text'>
              <span className="redundant">for</span> Consumers
              <div className="line"></div>
            </div>
          </NavLink>
          <Signup buttonLabel={ signupLabel } />
          <a href={ getDashboardDomain() } className="login-button">
            <SigninIcon /> <span className="text">Login</span>
          </a>
          {/* { contactSignupModal } */}
          {/* <Account /> */}
        </nav>
      </div>
    );
  }
}

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  logout: PropTypes.func,
  menuOpen: PropTypes.bool,
  setMobileMenuOpen: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
